import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

import { Link, Redirect} from 'react-router-dom';

import InputMask from 'react-input-mask';
import Select from 'react-select';
import Toggle from 'react-toggle';
import getLocale from '../../i18n/getLocale';
import Topo from '../Layout/Topo';
import Overlay from '../Miscelania/Overlay';

class AircraftManeuveringAreaPeriodsEdit extends Component {

  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open',
      },
      redirect_url: false,
      loaded: 0,
      errors_listing: false,
      errors_messages: [],
      id: null,
      aircraft_id: null,
      location_id: null,
      start_date: null,
      end_date: null,
      aircrafts_select: [],
      locations_select: [],
    };
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);
    this.locale = getLocale();
    this.loadData = this.loadData.bind(this);
    this.edit = this.edit.bind(this);
  }
  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }
  handleToggleChange (name, event) {
    var change = {};
    if (event.target.checked === true) {
      var value = 1;
    } else {
      var value = 0;
    }
    change[name] = value;
    this.setState(change);
  }
  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }

  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }

  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});
    }
  }

  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }

  componentDidMount () {
    this.refs.request_api.header();
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.state.loaded === 1 && prevState.loaded === 0) {
      this.setState({loaded: 2}, this.loadData());
    }
  }

  loadData () {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      var url = config.get('api') + '/reboque/aeronave/'+self.props.match.params.id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url', '/reboque/aeronaves');
        if (responseJson.status === 'success') {
          self.setState({
            id: responseJson.data.main.id,
            aircraft_id: responseJson.data.main.aircraft_id,
            location_id: responseJson.data.main.location_id,
            start_date: responseJson.data.main.start_date_str,
            end_date: responseJson.data.main.end_date_str,
            total_time: responseJson.data.main.total_time_str,
          });
          self.setState({ aircrafts_select: responseJson.data.aircrafts_select });
          self.setState({ locations_select: responseJson.data.locations_select });

        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        self.handleMessage();
      });
    });
  }

  // Fetch salvando a edição
  edit(event) {
    event.preventDefault();
    this.handleAlert('', '', 'open');
    var datasave = {
      id: this.state.id,
      aircraft_id: this.state.aircraft_id,
      location_id: this.state.location_id,
      start_date: this.state.start_date,
      end_date: this.state.end_date,
    };
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/reboque/aeronave', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          self.setState({
            id: responseJson.data.id,
            aircraft_id: responseJson.data.aircraft_id,
            location_id: responseJson.data.location_id,
            start_date: responseJson.data.start_date_str,
            end_date: responseJson.data.end_date_str,
            total_time: responseJson.data.total_time_str,
          });
        }

        if (responseJson.status === 'warning') {
          self.setState({errors_listing: true, errors_messages: responseJson.data});
          self.handleAlert(responseJson.message, responseJson.status, 'closed');
        } else {
          self.handleAlert(responseJson.message, responseJson.status, 'open');
        }
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  render() {
    var self = this;
    return (
<div>
  <Topo></Topo>
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  <div className="container-liquid">
    <div className="conteudo">
      <h3 className="page-title pull-left">{this.locale.PeriodoReboqueAeronave.EditarPeriodoReboqueAeronave.titulo}</h3>
      <Link to="/reboque/aeronaves" className="btn btn-default pull-right"><i className="fa fa-chevron-left"></i> {this.locale.general.voltar}</Link>
      <div className="clearfix"></div>
      <hr/>
      {this.state.errors_listing &&
        <div className="alert alert-danger alert-dismissible" role="alert" style={{marginTop: 25}}>
          <button onClick={() => self.setState({ errors_listing: false, errors_messages: [], })} type="button" className="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
          <strong>{self.locale.PeriodoReboqueAeronave.EditarPeriodoReboqueAeronave.tituloErro}:</strong>
          {Object.keys(self.state.errors_messages).map(function(k) {
            var message = self.state.errors_messages[k];
            return (
              <p>- {message}</p>
            );
          })}
        </div>
      }
      <form onSubmit={this.edit}>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.PeriodoReboqueAeronave.EditarPeriodoReboqueAeronave.formulario.Aeronave}:</label>
              <Select
                className="form-field-name"
                name="aircraft_id"
                value={this.state.aircraft_id}
                searchable={true}
                placeholder={this.locale.PeriodoReboqueAeronave.EditarPeriodoReboqueAeronave.formulario.placeholder.SelecioneAeronave}
                onChange={this.handleSelectChange.bind(this, 'aircraft_id')}
                options={this.state.aircrafts_select}
                required
              />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.PeriodoReboqueAeronave.EditarPeriodoReboqueAeronave.formulario.Localidade}:</label>
              <Select
                className="form-field-name"
                name="location_id"
                value={this.state.location_id}
                searchable={true}
                placeholder={this.locale.PeriodoReboqueAeronave.EditarPeriodoReboqueAeronave.formulario.placeholder.SelecioneLocalidade}
                onChange={this.handleSelectChange.bind(this, 'location_id')}
                options={this.state.locations_select}
                required
              />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.PeriodoReboqueAeronave.EditarPeriodoReboqueAeronave.formulario.Inicio}:</label>
              <InputMask value={this.state.start_date}  maskChar={null} name="start_date" mask="99/99/9999 99:99" className="form-control" onChange={this.handleChange.bind(this, 'start_date')} placeholder="dd/mm/aaaa hh:mm" required />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.PeriodoReboqueAeronave.EditarPeriodoReboqueAeronave.formulario.Fim}:</label>
              <InputMask value={this.state.end_date}  maskChar={null} name="end_date" mask="99/99/9999 99:99" className="form-control" onChange={this.handleChange.bind(this, 'end_date')} placeholder="dd/mm/aaaa hh:mm" />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.PeriodoReboqueAeronave.EditarPeriodoReboqueAeronave.formulario.TempoTotal}:</label>
              <InputMask value={this.state.total_time} name="total_time" className="form-control" disabled />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <button type="submit" className="btn btn-primary btn-lg btn-block"><i className="fa fa-fw fa-save"></i> {this.locale.PeriodoReboqueAeronave.EditarPeriodoReboqueAeronave.formulario.botaoSalvarEdicao}</button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
    );
  }
}

export default AircraftManeuveringAreaPeriodsEdit;



// WEBPACK FOOTER //
// ./src/Components/AircraftManeuveringAreaPeriods/AircraftManeuveringAreaPeriodsEdit.js